export  function getDisciplines(powers) {
  const disciplinesSet = new Set()
  powers.forEach(power => disciplinesSet.add(power.discipline))
  return disciplinesSet
}